import React, { useState, useEffect } from "react";
import ReactTable from "react-table";
import Pagination from "../../../components/DatatablePagination";
import { ComponentTitle, ComponentBody } from "./Common";
import { AddCommaNumber } from "../../../helpers/Utils";
import IntlMessages from "../../../helpers/IntlMessages";

export default (props) => {
  const [state, setState] = useState({
    columns: [],
  });

  useEffect(() => {
    setState({
      ...state,
      columns: [
        {
          Header: <div style={{ textAlign: "center" }}>{props.title}</div>,
          columns: [
            {
              Header: <IntlMessages id="analytics.table.stt" />,
              accessor: "stt",
              maxWidth: 40,
            },
            {
              Header: <IntlMessages id="analytics.table.product" />,
              accessor: "label",
              minWidth: 150,
            },
            {
              Header: (
                <ComponentTitle
                  compare={props.setting.compare}
                  title={<IntlMessages id="analytics.table.sold_quantity" />}
                  value={props.total_count}
                  align="center"
                />
              ),
              accessor: "count",
              Cell: (_props) => {
                const value = _props.value + " SP";
                return (
                  <ComponentBody
                    compare={props.setting.compare}
                    all={props.setting.all}
                    type="text"
                    align="center"
                    value={value}
                    compare_value={_props.original.compare_count}
                  />
                );
              },
            },
            {
              Header: (
                <ComponentTitle
                  compare={props.setting.compare}
                  title={<IntlMessages id="analytics.table.revenue" />}
                  value={AddCommaNumber(props.total_price)}
                  align="end"
                />
              ),
              minWidth: 120,
              accessor: "price",
              sortMethod: (a, b) => Number(a) - Number(b),
              Cell: (_props) => (
                <ComponentBody
                  compare={props.setting.compare}
                  all={props.setting.all}
                  type="price"
                  align="end"
                  value={_props.value}
                  compare_value={_props.original.compare_price}
                />
              ),
            },
          ],
        },
      ],
    });
  }, [props.data, props.setting.compare, props.setting.all]);

  return (
    <ReactTable
      defaultPageSize={6}
      data={props.data}
      columns={state.columns}
      minRows={0}
      showPageJump={false}
      showPageSizeOptions={true}
      PaginationComponent={Pagination}
      NoDataComponent={() => null}
    />
  );
};
